import { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";

const COLLECTIONS = [
  { key: "visaRequests",       label: "Visa Requests" },
  { key: "jobSeekers",         label: "Job Seekers" },
  { key: "companySubmissions", label: "Company Submissions" },
  { key: "generalInterest",    label: "General Interest" },
];

export default function OverviewTab() {
  const [counts, setCounts] = useState({});

  useEffect(() => {
    const unsubs = COLLECTIONS.map(({ key }) =>
      onSnapshot(collection(db, key), snap => {
        setCounts(prev => ({ ...prev, [key]: snap.size }));
      })
    );
    return () => unsubs.forEach(u => u());
  }, []);

  return (
    <div className="acard">
      <div className="atitle">Overview</div>
      <div className="stat-grid">
        {COLLECTIONS.map(({ key, label }) => (
          <div className="stat-card" key={key}>
            <div className="stat-num">{counts[key] ?? "…"}</div>
            <div className="stat-lbl">{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
